import { render, staticRenderFns } from "./task_chat_room.vue?vue&type=template&id=3eecf3dd&scoped=true&lang=html&"
import script from "./task_chat_room.vue?vue&type=script&lang=js&"
export * from "./task_chat_room.vue?vue&type=script&lang=js&"
import style0 from "./task_chat_room.vue?vue&type=style&index=0&id=3eecf3dd&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eecf3dd",
  null
  
)

export default component.exports